/**
 * A set of methods for interacting with the session storage of the browser 
 * specifically for the interjection of drawers when a user has closed them previously.
 */

// Default storege items used when initiating
// @todo move these keys to constants
export const defaultSessionValues = {
  WTSessionActive: true,
  WTcartType: '',
}

/**
 * Set a session storage item
 * @param {string} key 
 * @param {string} value 
 * @returns 
 */
export const setSessionStorageItem = (key, value) => {
  if(!key || !value) { 
    return false
  }
  sessionStorage.setItem(key, value)
}

/**
 * Get a sessions torage item
 * @param {string} key 
 * @returns {string}
 */
export const getSessionStorageItem = (key) => {
  if(!key) {
    return undefined
  }
  return sessionStorage.getItem(key)
}

/**
 * 
 * @param {Object} defaults 
 * @returns 
 */
export const initSessionStorage = (defaults) => {
  Object.keys(defaults).forEach(key => setSessionStorageItem(key, defaults[key]))
  return true
}

/**
 * 
 * @param {string} value -  "open" | "closed"
 * @returns 
 */
export const changeCartSessionState = (value) => {
  const currentState = getSessionStorageItem('WTcartClosedWhenFixed')
  return setSessionStorageItem('WTcartClosedWhenFixed', value)
}

/**
 * checks the open closed status and returns as a bool
 * @returns {boolean}
 */
export const fixedCartShouldOpenOnLoad = () => {
  const currentState = getSessionStorageItem('WTcartClosedWhenFixed')
  return currentState !== 'closed'
}

/**
 * Used on each theme init to make surte we have a session active to use.
 * @param {Object} userDefaults 
 * @returns {Object}
 */
export const sessionHandler = (userDefaults = {}) => {
  // init sessions or maintain current state if in place. 
  const isActive = getSessionStorageItem('WTSessionActive')
  // Merge in the user overrides
  const defaults = Object.assign({}, defaultSessionValues, userDefaults)

  if(!isActive) {
    initSessionStorage(defaults)
  }

  if(userDefaults.WTcartType) {
    setSessionStorageItem('WTcartType', userDefaults.WTcartType)
    // Reset the open closed status
    if(userDefaults.WTcartType !== 'persistent') {
      setSessionStorageItem('WTcartClosedWhenFixed', 'open')
    }
  }

  // @todo clean up
  return {
    changeCartSessionState,
    defaultSessionValues,
    fixedCartShouldOpenOnLoad, 
    getSessionStorageItem,
    initSessionStorage,
    mergedDefaults: defaults,
    setSessionStorageItem,
    userDefaults,
  }

}

export default sessionHandler